/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2022-07-28 10:40:25
 * @FilePath: \frontend\src\store\modules\app.js
 */
import Cookies from 'js-cookie';

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? Boolean(Number(Cookies.get('sidebarStatus'))) : true,
    withoutAnimation: false,
  },
  device: 'desktop',
  pubsub: {
    disconnected: false,
    reloading: false,
  },
  viewport: {
    breakpoint: 'lg',
    size: 'large',
    vpHeight: 0,
  },
  occupyingGW: {
    devId: '',
    areaId: '',
  },
};

const mutations = {
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_PUBSUB_DISCONNECTED: (state, flag) => {
    state.pubsub.disconnected = flag;
  },
  SET_PUBSUB_RELOADING: (state, flag) => {
    state.pubsub.reloading = flag;
  },
  SET_VIEWPORT: (state, viewport) => {
    state.viewport.breakpoint = viewport.breakpoint;
    state.viewport.size = viewport.size;
    state.viewport.vpHeight = viewport.vpHeight;
  },
  SET_OCCUPYINGGATEWAY: (state, gateway) => {
    state.occupyingGW.devId = gateway.devId;
    state.occupyingGW.areaId = gateway.areaId;
  },
  RESET_OCCUPYINGGATEWAY: (state) => {
    state.occupyingGW.devId = '';
    state.occupyingGW.areaId = '';
  },
};

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  },
  setPubSubDisconnected({ commit }, flag) {
    commit('SET_PUBSUB_DISCONNECTED', flag);
  },
  setPubSubReloading({ commit }, flag) {
    commit('SET_PUBSUB_RELOADING', flag);
  },
  setViewport({ commit }, viewport) {
    commit('SET_VIEWPORT', viewport);
  },
  setOccupyingGateway({ commit }, gateway) {
    commit('SET_OCCUPYINGGATEWAY', gateway);
  },
  resetOccupyingGateway({ commit }) {
    commit('RESET_OCCUPYINGGATEWAY');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
